import { api } from "./api";
import {
  GET_USER,
  GET_USER_BY_ID,
  REPORT_ISSUE,
  GENERATE_USER,
} from "../apiEndPoints";

export const userApiSlice = api.injectEndpoints({
  endpoints: (builder) => ({
    getUsers: builder.query({
      query: () => ({
        url: GET_USER,
        method: "GET",
      }),
    }),
    getUserByID: builder.query({
      query: (id) => ({
        url: `${GET_USER_BY_ID}/${id}`,
        method: "GET",
      }),
    }),
    reportIssue: builder.mutation({
      query: (payload) => ({
        url: REPORT_ISSUE,
        method: "POST",
        body: payload,
      }),
    }),
    updateUser: builder.mutation({
      query: ({ user_id, payload }) => ({
        url: `${GENERATE_USER}/${user_id}`,
        method: "PUT",
        body: payload,
      }),
    }),
  }),
});

export const {
  useGetUsersQuery,
  useGetUserByIDQuery,
  useReportIssueMutation,
  useUpdateUserMutation,
} = userApiSlice;
